module.exports = require("@mui/icons-material/InfoOutlined");